var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from 'react-popover';
import styled, { css } from 'styled-components';
var StyledPopover = styled(Popover)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & > .Popover-tip {\n    ", ";\n  }\n  flex-direction: column;\n"], ["\n  & > .Popover-tip {\n    ", ";\n  }\n  flex-direction: column;\n"])), function (props) {
    return props.bgColor &&
        props.borderColor && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fill: ", ";\n        margin-top: -1px;\n        stroke: ", ";\n      "], ["\n        fill: ", ";\n        margin-top: -1px;\n        stroke: ", ";\n      "])), props.bgColor, props.borderColor);
});
export var CustomPopover = function (props) {
    useEffect(function () {
        var handleKey = function (e) {
            if (e.key === 'Escape')
                props.onOuterAction();
        };
        if (props.onOuterAction) {
            document.addEventListener('scroll', props.onOuterAction);
        }
        document.addEventListener('keydown', handleKey);
        return function () {
            if (props.onOuterAction) {
                document.removeEventListener('scroll', props.onOuterAction);
            }
            document.removeEventListener('keydown', handleKey);
        };
    }, [props]);
    var body = props.body, bgColor = props.bgColor, tipSize = props.tipSize, borderColor = props.borderColor, onOuterAction = props.onOuterAction, preferPlace = props.preferPlace, place = props.place, isOpen = props.isOpen, offset = props.offset, children = props.children, borderRadius = props.borderRadius, bodyStyle = props.bodyStyle, popoverStyle = props.popoverStyle, bodyRef = props.bodyRef, enterExitTransitionDurationMs = props.enterExitTransitionDurationMs;
    return (_jsx(StyledPopover, __assign({ body: _jsx("div", __assign({ ref: bodyRef, style: __assign({ background: bgColor, border: "1px solid ".concat(borderColor), borderRadius: borderRadius, boxSizing: 'content-box' }, bodyStyle) }, { children: body })), onOuterAction: onOuterAction, preferPlace: preferPlace, place: place, isOpen: isOpen, bgColor: bgColor, borderColor: borderColor, tipSize: tipSize || 10, offset: offset || 0, enterExitTransitionDurationMs: enterExitTransitionDurationMs || 100, style: __assign({}, popoverStyle) }, { children: children })));
};
CustomPopover.propTypes = {
    bgColor: PropTypes.string,
    body: PropTypes.object,
    onOuterAction: PropTypes.func,
    preferPlace: PropTypes.string,
    place: PropTypes.string,
    isOpen: PropTypes.bool,
    children: PropTypes.object,
    borderColor: PropTypes.string,
    tipSize: PropTypes.number,
    offset: PropTypes.number,
    borderRadius: PropTypes.number,
    bodyStyle: PropTypes.object,
    popoverStyle: PropTypes.object,
    bodyRef: PropTypes.object,
    enterExitTransitionDurationMs: PropTypes.number,
};
export default CustomPopover;
var templateObject_1, templateObject_2;
